"use strict";
/* global jQuery Vue Inputmask */
/* eslint consistent-this: ["error", "self"] */

import Vue from "./../lib/vue.min";
import "inputmask";

(function($) {
    var popup;
    var auth;

    var enter_button;
    var enter_button_mob;
    var reg_button;
    var close_button;
    var edit_password_in_profile;

    var textSpan;
    var electrocardBlock;
    var electrocardEenterPhoneBlock;
    var cardNumber;
    var enterPassword;
    var enterSMS;
    var callBack;
    var phoneNumber;
    var forgotBlock;
    var registrationBlock;
    var entranceBlock;
    var authBlock;

    var _token = $('meta[name="csrf-token"]').attr("content");

    var keys = {
        48: 0,
        49: 1,
        50: 2,
        51: 3,
        52: 4,
        53: 5,
        54: 6,
        55: 7,
        56: 8,
        57: 9
    };

    function set_error(node) {
        node.closest(".prfl-field").classList.add("error");
    }

    function set_error_checkbox(node) {
        node.closest(".chek-wrap").classList.add("error");
    }

    $(document).ajaxSend(function() {
        if (auth) {
            auth.error = false;
        }
    });

    function hide_error(node) {
        node.closest(".prfl-field").classList.remove("error");
    }

    function hide_error_checkbox(node) {
        node.closest(".chek-wrap").classList.remove("error");
    }

    function hide_popup_node(node) {
        $(node).animate({ opacity: 0 }, 250, function() {
            node.style.display = "none";
        });
    }

    function PopupBox(back, front) {
        var self = this;
        self.show = function() {
            back.style.display = "block";
            back.style.opacity = "0";

            front.style.display = "block";
            front.style.opacity = "0";

            $(front).animate({ opacity: 1 }, 250);
            $(back).animate({ opacity: 0.7 }, 250);

            self.center();
            // front.style.top = window.pageYOffset + 20 + 'px';
        };

        self.hide = function() {
            auth.screen = "";
            hide_popup_node(back);
            hide_popup_node(front);
        };

        self.center = function() {
            front.style.top = window.pageYOffset + 20 + "px";
        };
    }

    function show_system_fail(data, textStatus, errorThrown) {
        auth.error = true;
        auth.error_code = data.status;
        auth.error_text = errorThrown;
    }

    function setCaretPosition(elemId, caretPos) {
        var elem = document.getElementById(elemId);
        var range;
        if (elem !== null) {
            if (elem.createTextRange) {
                range = elem.createTextRange();
                range.move("character", caretPos);
                range.select();
            } else if (elem.selectionStart) {
                elem.focus();
                elem.setSelectionRange(caretPos, caretPos);
            } else {
                elem.focus();
            }
        }
    }

    textSpan = {
        props: ["text"],
        template: "<span>{{ text }}</span>"
    };

    /* CARD NUMBER */
    cardNumber = {
        template: "#card_number_template",
        data: function() {
            return {
                card_number: "",
                load: false,
                // invalid_num: false,
                error: false,
                error_message: "",
                caret_position: 4,
                card_number_one: "",
                card_number_two: ""
            };
        },
        watch: {
            card_number_one: function() {
                this.check_one();
            },
            card_number_two: function() {
                this.check_two();
            }
        },
        mounted: function() {
            var self = this;
            var input = self.$el.querySelector("#card_number_one");
            input.focus();
            // setCaretPosition('card_number', self.caret_position);

            // Inputmask({
            //     placeholder: 'X',
            //     clearMaskOnLostFocus: false,
            //     oncomplete: function () {
            //         self.card_number = this.value;
            //         self.get_user_info();
            //     },
            //     onincomplete: function () {
            //         var value = input.value.replace(/X/gi, '').replace(/ $/, '');
            //         var len = value.length;

            //         if (len < 4) {
            //             len = 4;
            //         } else if (len === 9) {
            //             len = 10;
            //         }
            //         setCaretPosition('card_number', len);
            //         // input.selectionStart = this.selectionEnd = len;
            //     },
            //     onKeyValidation: function () {
            //         var value = input.value.replace(/X/gi, '').replace(/ $/, '');
            //         var len = value.length;

            //         if (len < 4) {
            //             len = 4;
            //         } else if (len === 9) {
            //             len = 10;
            //         }
            //         setCaretPosition('card_number', len);
            //         // input.selectionStart = this.selectionEnd = len;
            //     },
            // }).mask(input);
        },
        methods: {
            check_one: function() {
                var len;
                var holders = this.$el.querySelectorAll(".card_one span");
                var i = 0;

                this.card_number_one = this.card_number_one
                    .replace(/[^0-9]*/gi, "")
                    .slice(0, 5);
                len = this.card_number_one.length;

                for (; i < 5; i += 1) {
                    holders[i].style.opacity = i < len ? 0 : 1;
                }

                if (len >= 5 && this.card_number_two.length === 5) {
                    this.get_user_info();
                } else if (len >= 5) {
                    this.$el.querySelector("#card_number_two").focus();
                }
            },
            check_two: function() {
                var len;
                var holders = this.$el.querySelectorAll(".card_two span");
                var i = 0;

                this.card_number_two = this.card_number_two
                    .replace(/[^0-9]*/gi, "")
                    .slice(0, 5);
                len = this.card_number_two.length;

                for (; i < 5; i += 1) {
                    holders[i].style.opacity = i < len ? 0 : 1;
                }

                if (len >= 5 && this.card_number_one.length === 5) {
                    this.get_user_info();
                }
            },
            focus: function() {
                if (this.card_number_one.length < 5) {
                    this.$el.querySelector("#card_number_one").focus();
                }
            },
            backspace: function(e) {
                if (e.keyCode === 8 && this.card_number_two.length === 0) {
                    this.$el.querySelector("#card_number_one").focus();
                }
            },
            get_user_info: function() {
                var self = this;

                self.card_number =
                    "295" + self.card_number_one + self.card_number_two;

                self.load = true;
                self.invalid_num = false;

                auth.net_error = false;

                $.post("/auth/check_card", {
                    number: self.card_number.replace(/ +/g, ""),
                    _token: _token
                })
                    .done(function(data) {
                        var next_slide;

                        // debug
                        // next_slide = 'slide_enter_phone';
                        // auth.screen = next_slide;

                        if (data.status === "ok") {
                            auth.card_number = self.card_number;

                            if (!("tel" in data) || data.tel === "") {
                                auth.tel_number = "";
                                next_slide = "slide_enter_phone";
                            } else {
                                auth.tel_number =
                                    data.tel.slice(0, 3) +
                                    data.tel.slice(3).replace(/.(?=...)/g, "X");
                            }

                            if (data.new_user) {
                                if (auth.tel_number === "") {
                                    next_slide = "slide_enter_phone";
                                } else {
                                    next_slide = "slide_enter_sms";
                                }
                            } else if (auth.forgotten) {
                                // auth.tel_number = '+380 11 123 45 67';
                                next_slide = "slide_forgot_password";
                            } else {
                                next_slide = "slide_enter_password";
                            }

                            auth.screen = next_slide;
                        } else {
                            // self.invalid_num = true;
                            self.error_message = data.message;
                            self.error = true;
                        }
                    })
                    .fail(show_system_fail)
                    .always(function() {
                        self.load = false;
                    });
            },
            goto_auth: function() {
                auth.screen = "slide_auth";
            },
            goto_electrocard: function() {
                auth.screen = "slide_elecrtrocard_enter_phone";
            }
        }
    };

    /* ENTER PASSWORD */
    enterPassword = {
        template: "#enter_password_template",
        data: function() {
            return {
                pass_word: "",
                card_value: auth.card_number,
                remember: false,
                load: false,
                invalid_pass: false
            };
        },
        methods: {
            forgot_passwd: function() {
                auth.screen = "slide_forgot_password";
            },
            send_passwd: function() {
                var self = this;

                if (self.pass_word !== "") {
                    self.load = true;
                    self.invalid_pass = false;

                    auth.error = false;

                    // $.post('/', {pass: self.pass_word, remember: self.remember})
                    $.post("/auth/login", {
                        pass: self.pass_word,
                        remember: self.remember,
                        _token: _token,
                        dataType: "json"
                    })
                        .done(function(data) {
                            if (data.status == "ok") {
                                window.location = data.profile_path;
                            } else {
                                // auth.error = true;
                                auth.error_text = data.message;
                                self.invalid_pass = true;
                            }
                        })
                        .fail(function(data, textStatus, errorThrown) {
                            auth.error = true;
                            auth.error_text = data.message;
                            // self.invalid_pass = true;
                        })
                        .always(function() {
                            self.load = false;
                        });
                }
            }
        }
    };

    /* SMS */
    enterSMS = {
        template: "#enter_sms_template",
        data: function() {
            return {
                card_value: auth.card_number,
                phone_value: auth.tel_number,
                show_sms: false,
                sms_key: "",
                load: false,
                invalid_key: false,
                error: false,
                error_message: ""
            };
        },
        mounted: function() {
            var self = this;
            var input = self.$el.querySelector("#sms_key");

            input.focus();
            Inputmask({
                placeholder: "",
                clearMaskOnLostFocus: false,
                oncomplete: function() {
                    self.sms_key = this.value;
                    self.send_key();
                }
            }).mask(input);
        },
        updated: function() {
            if (this.show_sms) {
                this.$el.querySelector("#sms_key").focus();
            }
        },
        methods: {
            not_mine: function() {
                auth.screen = "slide_callback";
            },
            get_sms_key: function() {
                var self = this;
                $.post("/auth/request_sms", { empty: true, _token: _token })
                    .done(function(data) {
                        if (data.status === "ok") {
                            self.error = false;
                            self.show_sms = true;
                        } else {
                            self.error_message = data.message;
                            self.error = true;
                        }
                    })
                    .fail(show_system_fail)
                    .always(function() {
                        self.load = false;
                    });
            },
            send_key: function() {
                var self = this;
                self.load = true;

                $.post("/auth/check_sms", {
                    sms_key: self.sms_key,
                    _token: _token
                })
                    .done(function(data) {
                        if (data.status === "ok") {
                            auth.screen = "slide_registration";
                        } else {
                            self.error_message = data.message;
                            self.error = true;
                        }
                    })
                    .fail(show_system_fail)
                    .always(function() {
                        self.load = false;
                    });
            }
        }
    };

    /* CALLBACK */
    callBack = {
        template: "#callback_template",
        data: function() {
            return {
                card_number: auth.card_number,
                order_send: false,
                net_error: false,
                net_code: "",
                net_err: "",
                username: "",
                phone_number_callback: "",
                message: "",
                error_message: "",
                error: false,
                name: name
            };
        },
        updated: function() {
            popup.center();
        },
        mounted: function() {
            var self = this;
            var input = self.$el.querySelector("#phone_number_callback");
            //input.focus();
            //$('#phone_number_callback').mask('+38 (099) 999-99-99');
            Inputmask({
                placeholder: "",
                clearMaskOnLostFocus: false,
                oncomplete: function() {
                    self.phone_number_callback = this.value;
                }
            }).mask(input);
        },
        methods: {
            call_me: function(event) {
                var btn = event.target;
                var self = this;
                var params;
                self.error = false;
                hide_error(self.$el.querySelector("#username"));
                hide_error(self.$el.querySelector("#phone_number_callback"));
                if (self.username === "") {
                    set_error(self.$el.querySelector("#username"));
                } else if (self.phone_number_callback === "") {
                    set_error(self.$el.querySelector("#phone_number_callback"));
                } else {
                    btn.disabled = true;
                    params = {
                        pib: self.username,
                        phone_number_callback: self.phone_number_callback,
                        message: self.message,
                        name: self.name,
                        _token: _token
                    };

                    // $.post('/', {})
                    $.post("/auth/callback", params)
                        .done(function(data) {
                            if (data.status === "ok") {
                                self.order_send = true;
                            } else {
                                self.error_message = data.message;
                                self.error = true;
                            }
                        })
                        .fail(show_system_fail)
                        .always(function() {
                            btn.disabled = false;
                        });
                }
            },
            finish: function() {
                popup.hide();
            }
        },
        components: {
            text_span: textSpan
        }
    };

    /* PHONE NUMBER */
    phoneNumber = {
        template: "#enter_phone_template",
        data: function() {
            return {
                load: false,
                card_value: auth.card_number,
                phone_number: auth.tel_number,
                // forgotten: auth.forgotten,
                forgotten: false
            };
        },
        mounted: function() {
            var self = this;
            var input = self.$el.querySelector("#phone_number");
            input.focus();
            Inputmask({
                placeholder: "",
                clearMaskOnLostFocus: false,
                oncomplete: function() {
                    self.phone_number = this.value;
                }
            }).mask(input);
        },
        methods: {
            send_phone: function() {
                var tel = this.$el.querySelector("#phone_number").value;
                this.load = true;

                if (tel.length === 17) {
                    $.post("/auth/add_phone", {
                        phone_number: tel,
                        _token: _token
                    })
                        .done(function() {
                            auth.tel_number = tel;
                            auth.screen = "slide_enter_sms";
                        })
                        .fail(show_system_fail);
                }
            },
            not_mine: function() {
                auth.screen = "slide_callback";
            }
        }
    };

    /* FORGOT PASSWORD */
    forgotBlock = {
        template: "#forgot_password_template",
        data: function() {
            return {
                pass_word: "",
                phone_number: auth.tel_number,
                load: false,
                invalid_pass: false,
                sms_code: "",
                error: false,
                error_message: "",
                forgot_password_status: "screen_phone",
                forgotten: auth.forgotten,
                check_sms_count: 0,
                try_to_resend_sms: false
                // screen_phone - show phone and send sms button
                // screen_got_sms -- show fields sms and new password
                // screen_ok -- password changed, open login popup
                // screen_ok_close -- password changed, already loggined - just close window
            };
        },
        mounted: function() {
            console.log("this --- ", this);
            var self = this;
            var phone_in_forgot_template = self.$el.querySelector(
                "#phone_in_forgot_template"
            );
            if (phone_in_forgot_template.dataset.value !== "") {
                self.phone_number = phone_in_forgot_template.dataset.value;
            }
        },
        methods: {
            send_sms: function() {
                var self = this;
                self.forgotten = false;

                if (self.check_sms_count >= 6) {
                    self.forgot_password_status = "block_resend__password";
                    return;
                }

                $.post("/auth/request_sms", { empty: true, _token: _token })
                    .done(function(data) {
                        if (data.status === "ok") {
                            self.error = false;
                            self.forgot_password_status = "screen_got_sms";
                        } else if (data.status === "limit") {
                            self.error = true;
                            self.forgot_password_status =
                                "block_resend__password";
                        } else {
                            self.error_message = data.message;
                            self.error = true;
                        }
                    })
                    .fail(show_system_fail)
                    .always(function() {
                        self.load = false;
                    });
            },
            go_to_login: function() {
                //auth.screen = 'slide_enter_password';
                auth.screen = "slide_auth";
            },
            do_close: function() {
                popup.hide();
            },
            set_password: function() {
                var self = this;

                if (self.pass_word.length <= 5) {
                    return;
                }

                $.post("/auth/set_new_password", {
                    sms: self.sms_code,
                    password: self.pass_word,
                    _token: _token
                })
                    .done(function(data) {
                        if (data.status === "ok") {
                            self.error = false;
                            if (data.action === "just_close") {
                                self.forgot_password_status = "screen_ok_close";
                            } else {
                                self.forgot_password_status = "screen_ok";
                            }
                        } else if (data.status === "limit") {
                            self.error = true;
                            self.forgot_password_status =
                                "block_resend__password";
                            self.error_message = "";
                        } else {
                            self.error_message = data.message;
                            self.error = true;
                            self.check_sms_count = self.check_sms_count + 1;
                            if (self.check_sms_count % 2 === 0) {
                                self.try_to_resend_sms = true;
                            }
                        }
                    })
                    .fail(show_system_fail)
                    .always(function() {
                        self.load = false;
                    });
            },
            to_resend_sms: function() {
                var self = this;

                self.forgot_password_status = "screen_phone";
                self.error_message = "";
                self.try_to_resend_sms = false;
                self.sms_code = "";
                self.pass_word = "";
            },
            send_passwd: function() {
                var self = this;

                if (self.pass_word !== "") {
                    self.load = true;
                    self.invalid_pass = false;

                    auth.error = false;

                    // $.post('/', {pass: self.pass_word, remember: self.remember})
                    $.post("/auth/login", {
                        pass: self.pass_word,
                        remember: self.remember,
                        _token: _token,
                        dataType: "json"
                    })
                        .done(function(data) {
                            if (data.status == "ok") {
                                window.location = data.profile_path;
                            } else {
                                // auth.error = true;
                                auth.error_text = data.message;
                                self.invalid_pass = true;
                            }
                        })
                        .fail(function(data, textStatus, errorThrown) {
                            auth.error = true;
                            auth.error_code = data.status;
                            auth.error_text = errorThrown;
                        })
                        .always(function() {
                            self.load = false;
                        });
                }
            },
            not_mine: function() {
                auth.screen = "slide_callback";
            }
        }
    };

    /* REGISTRATION */
    registrationBlock = {
        template: "#registration_template",
        data: function() {
            return {
                reg_step: 0,
                load: false,
                user_info: {
                    card_number: auth.card_number,
                    phone_number: auth.tel_number,
                    last_name: "",
                    first_name: "",
                    middle_name: "",
                    email: "",
                    pass1: "",
                    pass2: ""
                    // error_email: false,
                },
                error_message: "",
                error: false,
                error_email: false,
                accept: false
            };
        },
        methods: {
            next_slide: function() {
                var self = this;
                var valid = true;
                self.error = false;
                self.error_email = false;
                if (self.reg_step === 0) {
                    if (self.user_info.last_name === "") {
                        valid = false;
                        set_error(self.$el.querySelector("#last_name"));
                    }
                    if (self.user_info.first_name === "") {
                        valid = false;
                        set_error(self.$el.querySelector("#first_name"));
                    }
                } else if (self.reg_step === 1) {
                    if (
                        !/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                            self.user_info.email
                        ) ||
                        self.user_info.email === ""
                    ) {
                        valid = false;
                        self.error_email = true;
                        set_error(self.$el.querySelector("#email"));
                    }
                } else if (self.reg_step === 2) {
                    if (
                        self.user_info.pass1 !== self.user_info.pass2 ||
                        self.user_info.pass1 === "" ||
                        self.user_info.pass1.length <= 5
                    ) {
                        valid = false;

                        set_error(self.$el.querySelector("#pass_1"));
                        set_error(self.$el.querySelector("#pass_2"));
                    }

                    if (!self.accept) {
                        valid = false;
                        set_error_checkbox(self.$el.querySelector("#accept"));
                    }

                    // valid = valid && self.accept;
                }

                if (valid) {
                    if (self.reg_step < 2) {
                        self.reg_step += 1;
                    } else {
                        self.register();
                    }
                }
            },
            hide_error: function(event) {
                hide_error(event.target);
            },
            hide_error_checkbox: function(event) {
                hide_error_checkbox(event.target);
            },
            register: function() {
                var self = this;
                self.load = true;
                $.post("/auth/registration", {
                    user_info: self.user_info,
                    _token: _token
                })
                    .done(function(data) {
                        if (data.status === "ok") {
                            self.load = true;
                            window.location = data.profile_path;
                        } else {
                            self.load = false;
                            self.error = true;
                            self.error_message = data.message;
                            set_error(self.$el.querySelector("#pass_1"));
                        }
                    })
                    .fail(show_system_fail);
            }
        },
        components: {
            text_span: textSpan
        }
    };

    /* AUTH */
    authBlock = {
        template: "#auth_template",
        data: function() {
            return {
                phone_number: "",
                pass_word: "",
                remember: false,
                load: false,
                invalid_pass: false
            };
        },
        mounted: function() {
            var self = this;
            var input = self.$el.querySelector("#phone_number");
            auth.forgotten = false;
            Inputmask({
                placeholder: "",
                clearMaskOnLostFocus: false,
                oncomplete: function() {
                    self.phone_number = this.value;
                }
            }).mask(input);
            input.addEventListener("change", event => {
                self.phone_number = event.target.value;
            });
        },
        methods: {
            goto_reg: function() {
                auth.screen = "slide_card";
            },
            goto_electro: function() {
                auth.screen = "slide_elecrtrocard_enter_phone";
            },
            forgot_passwd: function() {
                auth.forgotten = true;
                auth.screen = "slide_card";
            },
            send_passwd: function() {
                var self = this;

                if (self.pass_word !== "") {
                    self.load = true;
                    self.invalid_pass = false;

                    auth.error = false;

                    // $.post('/', {pass: self.pass_word, remember: self.remember})
                    $.post("/auth/auth", {
                        login: self.phone_number,
                        pass: self.pass_word,
                        remember: self.remember,
                        _token: _token
                    })
                        .done(function(data) {
                            if (data.status === "ok") {
                                window.location = data.profile_path;
                            } else {
                                auth.error = true;
                                auth.error_text = data.message;
                                self.invalid_pass = true;
                            }
                        })
                        // .fail(show_system_fail)
                        .fail(function(data, textStatus, errorThrown) {
                            auth.error = true;
                            auth.error_text = data.message;
                            self.invalid_pass = true;
                        })
                        .always(function() {
                            self.load = false;
                        });
                }
            }
        }
    };

    /* ENTRANCE */
    entranceBlock = {
        template: "#entrance_template",
        data: null,
        methods: {
            goto_auth: function() {
                auth.screen = "slide_auth";
            },
            goto_reg: function() {
                auth.screen = "slide_card";
            }
        }
    };

    /* Register */
    electrocardBlock = {
        template: "#electrocard_template",
        data: null,
        methods: {
            goto_get_electro: function() {
                auth.screen = "slide_elecrtrocard_enter_phone";
            },
            goto_reg: function() {
                auth.screen = "slide_card";
            }
        }
    };

    /* Reg electro card */
    electrocardEenterPhoneBlock = {
        template: "#electrocard_enter_phone_template",
        data: function() {
            return {
                load: false,
                phone_number: auth.tel_number,
                // forgotten: auth.forgotten,
                forgotten: false,
                error_message: "",
                error: false,
                show_sms: false,
                sms_key_electro: "",
                show_get_card_button: true,
                show_send_sms_button: false,
                user_info: {
                    card_number: "",
                    phone_number: ""
                }
            };
        },
        mounted: function() {
            var self = this;
            var input = self.$el.querySelector("#phone_number_electro");
            input.focus();
            Inputmask({
                placeholder: "",
                clearMaskOnLostFocus: false,
                oncomplete: function() {
                    self.phone_number = this.value;
                }
            }).mask(input);
        },
        methods: {
            send_phone: function(event) {
                var tel_holder = this.$el.querySelector(
                    "#phone_number_electro"
                );
                var tel = tel_holder.value;
                var btn = event.target;
                btn.disabled = true;
                this.load = true;
                var self = this;
                if (tel.length === 17) {
                    $.post("/auth/get_electro", {
                        phone_number: tel,
                        _token: _token
                    })
                        .done(function(data) {
                            if (data.status === "ok") {
                                //auth.tel_number = tel;
                                //auth.screen = 'slide_enter_sms';
                                self.load = false;
                                self.show_sms = true;
                                self.show_get_card_button = false;
                                self.show_send_sms_button = true;
                                tel_holder.disabled = true;
                            } else {
                                self.load = false;
                                self.error_message = data.message;
                                self.error = true;
                            }
                        })
                        .fail(show_system_fail)
                        .always(function() {
                            btn.disabled = false;
                        });
                }
            },
            send_with_sms: function() {
                var sms_key_electro = this.$el.querySelector("#sms_key_electro")
                    .value;
                var self = this;
                //  if (sms_key_electro.length === 4) {
                self.load = true;
                $.post("/auth/virtual_card_check_sms", {
                    sms_key: self.sms_key_electro,
                    _token: _token
                })
                    .done(function(data) {
                        if (data.status === "ok") {
                            auth.screen = "slide_registration";
                            auth.card_number = data.card_number;
                            auth.tel_number = data.phone_number;
                        } else {
                            self.error_message = data.message;
                            self.error = true;
                        }
                    })
                    .fail(show_system_fail)
                    .always(function() {
                        self.load = false;
                    });
                //                }else{
                //                    alert(1);
                //                }
            },
            get_card: function() {
                auth.screen = "slide_card";
            },
            goto_login: function() {
                auth.screen = "slide_auth";
            }
        }
    };

    function show_enter_card_number(section) {
        // go_to_block = go_to || 'slide_auth';

        // console.log(arguments.length);
        if (!auth) {
            auth = new Vue({
                el: "#auth_form",
                template: "#form_template",
                data: function() {
                    return {
                        // screen: DEV_IP === '192.168.0.13' ? 'slide_registration' : 'slide_card',
                        // 'slide_auth', 'slide_entrance', 'slide_enter_password'
                        // screen: 'slide_entrance',
                        screen: "",
                        card_number: "",
                        tel_number: "",
                        error: false,
                        error_code: "",
                        error_text: "",
                        forgotten: false
                    };
                },
                components: {
                    electrocard_block: electrocardBlock,
                    electrocard_enter_phone_block: electrocardEenterPhoneBlock,
                    entrance_block: entranceBlock,
                    auth_block: authBlock,
                    card_number_block: cardNumber,
                    enter_password_block: enterPassword,
                    enter_sms_block: enterSMS,
                    callback_block: callBack,
                    enter_phone_block: phoneNumber,
                    registration_block: registrationBlock,
                    forgot_password_block: forgotBlock
                },
                updated: popup.center
            });

            auth.screen = "slide_auth";

            if (section === "slide_electrocard") {
                auth.screen = "slide_electrocard";
            }
        } else {
            auth.screen = "slide_auth";

            if (section === "slide_electrocard") {
                auth.screen = "slide_electrocard";
            }
        }

        popup.show();
    }

    function init() {
        enter_button = document.getElementById("enter_button");
        enter_button_mob = document.getElementById("enter_button_mob");
        reg_button = document.getElementById("reg_button");
        close_button = document.getElementById("close_popup_button");
        edit_password_in_profile = document.getElementById(
            "change_password_in_profile"
        );

        if (
            ((enter_button || reg_button) && close_button) ||
            edit_password_in_profile
        ) {
            popup = new PopupBox(
                document.getElementById("shadow_box"),
                document.getElementById("popup_block")
            );

            if (edit_password_in_profile) {
                edit_password_in_profile.addEventListener("click", function() {
                    show_enter_card_number();
                    auth.screen = "slide_forgot_password";
                });
            }
            if (enter_button) {
                enter_button.addEventListener("click", function(e) {
                    e.preventDefault();
                    show_enter_card_number();
                });
            }
            if (enter_button_mob) {
                enter_button_mob.addEventListener("click", function(e) {
                    e.preventDefault();
                    show_enter_card_number();
                });
            }
            if (reg_button) {
                reg_button.addEventListener("click", function() {
                    show_enter_card_number("slide_electrocard");
                });
            }
            close_button.addEventListener("click", popup.hide);

            window.show_enter_card_number = show_enter_card_number;

            var url = new URL(window.location.href);
            var login = url.searchParams.get("login");

            if (login) {
                show_enter_card_number();
            }
        }
    }

    document.addEventListener("DOMContentLoaded", init);
})(jQuery);
